import HomeBody from '../utils/homeBody';
export default function Home(){
    return (
        <>
           <HomeBody/>
        </>
    )
}